










import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { setStorage } from "@common/utils";
import Menu from "@/zh-website/src/components/website/Menu.vue";
import BottomFoot from "@/zh-website/src/components/website/BottomFoot.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
@Component({
  components: {
    Menu,
    BottomFoot,
    SideBar,
    Banner
  }
})
export default class Index extends Vue {
  list = {
    style: {
      "background-image": `url(${require("../../assets/pic31.png")})`,
      height: "280px"
    },
    font1: "招聘中心",
    font2: "",
    font3: "与高人为伍，和世界握手",
    font4: "",
    font5: "",
    button: ""
  };
}
